<style scoped>
.radiobox-input:checked + svg {
    display: block;
}
.disabled-input {
    opacity: 0.5;
}
</style>
<template>
    <label
        class="flex items-center"
        :class="{
            'disabled-input': disabled
        }"
    >
        <div
            class="bg-white border rounded-full border-primary w-6 h-6 flex flex-shrink-0 justify-center items-center"
            :class="{ 'mr-1': !!$slots.default }"
        >
            <input
                type="radio"
                :checked="value === checkedValue"
                @change="emitInput"
                class="radiobox-input opacity-0 absolute"
                :disabled="disabled"
            />
            <svg
                class="fill-current hidden w-6 h-6 text-primary  pointer-events-none"
                viewBox="0 0 20 20"
            >
                <circle cx="10" cy="10" r="8" />
            </svg>
        </div>
        <div class="select-none flex-1" v-if="$slots.default">
            <slot></slot>
        </div>
    </label>
</template>

<script>
export default {
    props: {
        value: {},
        checkedValue: {},
        disabled: { type: Boolean, default: false }
    },
    methods: {
        emitInput(ev) {
            if (ev.target.checked) {
                this.$emit('input', this.checkedValue);
            }
        }
    }
};
</script>
